'use strict';

var sharedConfig = require('shared/config');

module.exports = {
    SERVICE_URL: _discoverServiceUrl(),
    RECEIVER_PATH: 'receiver/',
    WIDGET_PREFIX: sharedConfig.WIDGET_PREFIX,
    WIDGET_ID_PARAM_NAME: sharedConfig.WIDGET_ID_PARAM_NAME
};

// TODO: unit test this
function _discoverServiceUrl() {

    var associatedScriptTag = document.getElementById('iVisWidgetScript'),
        hasGlobalConfigurationObject = typeof (iVisWidgetConfiguration) !== 'undefined',
        hasServiceUrlDefined = hasGlobalConfigurationObject && iVisWidgetConfiguration.hasOwnProperty('SERVICE_URL');

    if (!associatedScriptTag && !hasServiceUrlDefined) {
        throw new Error('iVis Widget couldn\'t discover it\'s server host. Check if script tag with id="iVisWidgetScript" exists in DOM');
    }

    if (hasServiceUrlDefined) {
        return iVisWidgetConfiguration.SERVICE_URL;
    }

    return associatedScriptTag.getAttribute('src').replace('widget/widget.js', '');
}



//////////////////
// WEBPACK FOOTER
// ./src/widget/scripts/lib/config/main.js
// module id = 5
// module chunks = 0 1